import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=9d1bdade&scoped=true&"
import script from "./ShopList.vue?vue&type=script&lang=js&"
export * from "./ShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1bdade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d1bdade')) {
      api.createRecord('9d1bdade', component.options)
    } else {
      api.reload('9d1bdade', component.options)
    }
    module.hot.accept("./ShopList.vue?vue&type=template&id=9d1bdade&scoped=true&", function () {
      api.rerender('9d1bdade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Shops/ShopList.vue"
export default component.exports